
import {
    faEdit
} from "@fortawesome/free-solid-svg-icons";
export const RENT_LIST = 'rentlist';
export const RENT_SUBLIST = 'rentsublist';
export const ITEM = 'item';
export const GRID = 'grid';
export const LIST = 'list';
export const CHECK_TERM = ' - ';
export const ACTION_EDIT = 'action_edit';
export const EDIT = 'edit';
export const DELETE = 'delete';
export const RENTEDIT_CUSTOMER = 'rentedit_customer';
export const BREAKLINE = 'breakline';
export const TEXT = 'text';
export const INPUT = 'input';
export const COLLAPSE = 'collapse';
export const TEXT_FROM_CHILDREN = 'text_from_children';
export const READONLY = 'readonly';
export const CHECKBOX = 'checkbox';
export const SPLIT = 'split';
export const INFO = 'info';
export const DATES = "dates";
export const ONLY_CART = "onlyForCart";
export const BUTTON = 'button';
export const LINK = 'link';
export const TEXTAREA = 'textarea';
export const COMPLEX = 'complex';
export const DROPDOWN = 'dropdown';
export const CALENDAR = 'calendar';
export const DATE = 'date';
export const ADD_TWO_HOURS = 2 * 60 * 60 * 1000;
export const SHOWDATES = 'showdates';
export const INDEX = 'index';
export const COMBINE = 'combine';
export const SHOWS = 'shows';
export const DUMMY_X = 'XXXXXX';
export const HEADING = 'heading';

export const RE_FIRST_WORK = 'rentedit_firstrow_work';
export const RE_SECOND_ITEM = 'rentedit_secondrow_item';
export const RE_SECOND_DATES = 'rentedit_secondrow_showdates';

export const RE_DELIVER_ADD = 'rentedit_deliveryadd';
export const RE_INVOICE_ADD = 'rentedit_invoiceadd';
export const RE_PRICES = 'rentedit_prices';

export const RENTAL_SEARCH_ITEMS = [
    //{ name: "rentid", intl: "ecommerce.rentalsearch", required: true, type: "text" },
    { name: "fulltext", intl: "ecommerce.rentalsearch", required: true, type: "text" },
];

export const RENTAL_STATUS_ITEMS = [
    {name: 'status', intl: "rental.status", type: "dropdown", onDDClick: "onStatusClk", data: [
         { name: DUMMY_X, intl: "rental.status", value: DUMMY_X},
         { name: "cart", intl: "rental.status.cart", value: "cart"},
         {name: "request", intl:"rental.status.request", value: "request"},
         {name: "offer", intl:"rental.status.offer", value: "offer"},
         {name: "accepted", intl:"rental.status.accepted", value: "accepted"},
         {name: "archived", intl:"rental.status.archived", value: "archived"}
    ]}
];


export const RENTALLIST_ITEMS_ACTIONS = [
    { name: "edit", icon: faEdit, action: "edit", intl: "ecommerce.edit", htmlClasses: "rentitem-btn" }
];

export const RE_COMMENT_ITEMS = [
    { name: "comment", intl: "ecommerce.comment", type: "textarea", field: 'comment', isRentel: true },
];

export const RE_NOTE_ITEMS = [
    { name: "internnote", intl: "ecommerce.internnote", type: "text", field: 'internnote', withLabel: true },
];

export const RE_PRICES_OBJ = {
    "name": "Prices",
    "tab": "ecommerce.prices",
    "intl": "ecommerce.prices",
    "field": "prices",
    "order": 1,
    data: [
        { name: 'rentalprice', "intl": "ecommerce.rentalprice", field: 'rental', type: 'text' },
        { name: 'licence', "intl": "ecommerce.licence", field: 'licence', type: 'text' },
        { name: 'breakline', type: 'breakline' },
        { name: 'shipping', "intl": "ecommerce.shipping", field: 'shipping', type: 'text' },
        { name: 'decrypt', "intl": "ecommerce.decrypt", field: 'decrypt', type: 'text' },
        { name: 'edit', "intl": "ecommerce.processing", field: 'edit', type: 'text' },
        { name: 'tax', "intl": "ecommerce.tax", field: 'tax', type: 'text' },
        { name: 'breakline', type: 'breakline' },
        { name: 'total', "intl": "ecommerce.subtotal", field: 'total', type: 'text', htmlClasses: 'rentedit_bold' },
    ],
    "type": "complex"
};


export const RE_STATUS_ITEMS = [
     {name: 'process', type: 'text', intl: "rental.process", field: 'id'},
     {name: 'status', intl: "rental.status", type: "text", field: 'status',checkDisplay: true, 
        htmlClass: 'rentedit-end', color: 'rentedit-red',
        data: [
         { name: "cart", intl: "rental.status.cart", value: "cart"},
         {name: "request", intl:"rental.status.request", value: "request"},
         {name: "offer", intl:"rental.status.offer", value: "offer"},
         {name: "accepted", intl:"rental.status.accepted", value: "accepted"},
         {name: "archived", intl:"rental.status.archived", value: "archived"}
    ]}
];

export const RE_TRANSPORT = 'rentedit_itemstable';

// TRANSPORT PART BEGIN
export const ANALOG ='analog';
export const DIGITAL = 'digital';
export const TOTAL = 'total';
//export const ANALOG_TYPES = ['VIDEO','FILM','VIDEO_DIGITAL','VIRTUAL', 'VHS'];
export const DIGITAL_TYPES = ['DIGITAL'];
export const CURRENCY = '€';

export const PRICECAT_ITEMS = [
 {
    name: 'pricecat', intl: 'rental.ddpricecat', type: 'dropdown', field: 'pricecat', onClk: "onDDClick",
    data: [
      { name: 'inland', intl: 'rental.pricecat.domestic_show' },
      { name: 'price2', intl: 'rental.pricecat.small_community_cinema' },
      { name: 'science', intl: 'rental.pricecat.scientific_use' },
      { name: 'festival', intl: 'rental.pricecat.abroad_festivals' },
    ]
  }
];

export const RENTEDIT_U = "u_";
export const RENTEDIT_R = "r_";

export const PAY_ITEMS = [
    {name: 'precharge', intl: 'rental.precharge', type: 'checkbox', field: 'precharge'},
    {name: 'holdback', intl: 'rental.holdback', type: 'checkbox', field: 'holdback'},
];

export const EDITOR_ITEMS = [
    {name: 'editor', intl: 'rental.ddincharge', type: 'text'},
    {
        name: 'incharge', intl: 'rental.ddincharge', type: 'dropdown', field: 'incharge', onClk: "onDDClick",
          data: [
            { name: 'Anke Hahn', value: 'Anke Hahn' },
            { name: 'Niklas Huetter', value: 'Niklas Huetter'},
        ]
    }
];

export const NOTE_ITEMS = [
    {name: 'internalnoteLabel', intl: 'rental.internalnote', type: 'text'},
    {name: 'internalnote', intl: 'rental.internalnote', type: 'textarea', field: 'internalnote'},
    {name: 'internalnoteHelp', intl: 'rental.internalnotehelp', type: 'text'},
];

export const ACCEPT_ITEMS = [
    {name: 'acceptuntil', intl: 'rental.acceptuntil', type: 'text'},
    {name: 'acceptuntil', intl: 'rental.acceptuntil', type: 'calendar', field: 'acceptuntil'},
];

export const ITEMCHANGE_ITEMS = [
     {name: 'itemchange', intl: 'rentedit.itemchange.heading', type: 'heading'},
     {name: 'priref', intl: 'rentedit.itemId', type: 'input', field: 'priref', isSearchBtn: true}
];


export const ITEMADD_ITEMS = [
     {name: 'itemadd', intl: 'rentedit.itemadd.heading', type: 'heading'},
     {name: 'priref', intl: 'rentedit.itemId', type: 'input', field: 'priref', isSearchBtn: true}
]

export const ITEMCHANGE_BTN_ITEMS = [
     {name: 'back', intl: 'rentedit.itemchange.back', type: 'button', action: 'cancel'},
     {name: 'save', intl: 'rentedit.itemchange.save', type: 'button', action: 'save'}
];

export const SAVE = 'save';
export const CANCEL = 'cancel';
export const RE_ITEMCHANGE = 'itemchange';
export const R_LIEFNAME = 'r_liefnachname';
export const RENTID = 'rentid';

